import { Link } from "react-router-dom";

function Project(props) {
  return (
    <div className="Project">
      <Link to={props.link}>
        <img src={props.image} alt={props.alt} loading="lazy" />
      </Link>
        <div className="project_info">
          <h3>{props.title}</h3>
          <p>{props.description}</p>
        </div>
    </div>
  );
}

export default Project;
